/*
 * @Author: fan.lion@foxmail.com
 * @Date: 2020-02-18 14:45:32
 * @Last Modified by: zhiwei.luo@zuolin.com
 * @Last Modified time: 2021-06-16 15:57:29
 *
 * 店铺设置
 */

import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
import Loadable from 'react-loadable';
import { NProgressLoading as Loading } from 'components';

const Spin = () => <Loading loading />;

const ShopEdit = Loadable({
	loader: () => import('./routes/shop-edit'),
	loading: Spin,
});

const Main = Loadable({
	loader: () => import('./main'),
	loading: Spin,
});

export default ({ match }) => (
	<Switch>
		<Route path={`${match.url}/edit`} component={ShopEdit} />
		<Route path={match.url} component={Main} />
	</Switch>
);
